import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { Select } from "antd";
import { FaSpinner } from "react-icons/fa";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ResetPasswordModal from "../Administrations/ResetPasswordModal";

const oneYearFromNow = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d;
};

const UpdateUser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = location.state?.user; // Get user data from navigation state
    const [isLoading, setIsLoading] = useState(false);

    // Initialize form data with user data or empty values
    const [formData, setFormData] = useState({
        name: user?.firstname || "",
        lastname: user?.lastname || "",
        email: user?.email || "",
        username: user?.username || "",
        personalId: user?.personalId || "",
        role: user?.role || 0,
        userID: user?.userID || "",
        phoneNumber: user?.phoneNumber || "",
        kind: user?.kind || 1,
        signupDatetime: user?.signupDatetime ? new Date(user.signupDatetime) : new Date(),
        expirationDatetime: user?.expirationDatetime
            ? new Date(user.expirationDatetime)
            : oneYearFromNow(),
        systemNumber: user?.systemNumber || "",
    });
    const [neverExpire, setNeverExpire] = useState(!user?.expirationDatetime);
    
    const [showEtcField, setShowEtcField] = useState(user?.role === 1);


    const [deviceType, setDeviceType] = useState("");
    // Modal state
    const [resetModalVisible, setResetModalVisible] = useState(false);

    useEffect(() => {
        if (!user) {
            toast.error("کاربر یافت نشد!", { autoClose: 3000 });
            navigate("/dashboard/users"); // Redirect if no user data is available
        }
    }, [user, navigate]);


    useEffect(() => {
        async function fetchData() {
            var type = await axios.get(`${config.apiBaseUrl}/api/Users/GetUserDeviceType?id=${user.userID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "HeaderKey": config.HeaderKey,
                },
                withCredentials: true,
            })
            console.log("data ", type.data)
            setDeviceType(type.data);
        }
        if (user) {
            fetchData();
        }

    }, [user])
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.name === "role" ? parseInt(e.target.value) : e.target.value,
        });
    };

    const handleRole = (e) => {
        setFormData(prev => ({
            ...prev,
            role: e
        }));
        setShowEtcField(e === 1);
    };
    
    const handleKind = (e) => {
        setFormData(prev => ({
            ...prev,
            kind: e
        }));
    };
    
    const handleDateChange = (date) => {
        setFormData((prev) => ({
            ...prev,
            signupDatetime: date?.toDate?.() || new Date()
        }));
    };

    const handleExpirationDateChange = (date) => {
        setFormData((prev) => ({
            ...prev,
            expirationDatetime: date?.toDate?.() || oneYearFromNow()
        }));
    };
    
    const delay = async (ms) => {
        return new Promise((resolve) =>
            setTimeout(resolve, ms));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true);

            const parsedDate = new Date(formData.signupDatetime);
            const isValid = parsedDate instanceof Date && !isNaN(parsedDate);
            const isReasonable = isValid && parsedDate.getFullYear() >= 1990;

            if (!isReasonable) {
                formData.signupDatetime = new Date()
            }

            const payload = {
                ...formData,
                expirationDatetime: neverExpire ? null : formData.expirationDatetime,
            };

            const response = await axios.post(
                `${config.apiBaseUrl}/api/users/updateuser`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );

            toast.success(<p dir="rtl" className="font-custom">کاربر با موفقیت به‌روزرسانی شد!</p>, { autoClose: 1000 });
            await delay(1500);
            if (formData.role == 0) {
                navigate("/dashboard/users");
            } else {
                navigate("/dashboard/students");
            }
        } catch (error) {
            const errMsg = error.response?.data?.error || "خطای نامشخصی رخ داده است.";

            toast.error(<p dir="rtl" className="font-custom">{errMsg}</p>, { autoClose: 3000 });
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="max-w-md font-custom mx-auto bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-l text-center font-semibold text-gray-700 mb-4">ویرایش کاربر</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="flex gap-2">
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام خانوادگی</label>
                            <input
                                type="text"
                                name="lastname"
                                placeholder="نام خانوادگی"
                                onInvalid={(e) => {e.target.setCustomValidity("لطفاً نام خانوادگی کاربر را وارد کنید");}}
                                onInput={(e) => e.target.setCustomValidity("")}
                                value={formData.lastname}
                                onChange={handleChange}
                                className="w-full text-right p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="نام"
                                onInvalid={(e) => {e.target.setCustomValidity("لطفاً نام کاربر را وارد کنید");}}
                                onInput={(e) => e.target.setCustomValidity("")}
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full text-right p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="personalId" className="text-sm text-gray-600 mb-1">:کد ملی</label>
                            <input
                                type="text"
                                name="personalId"
                                placeholder="کد ملی"
                                value={formData.personalId}
                                onChange={handleChange}
                                onInvalid={(e) => {e.target.setCustomValidity("لطفاً کد ملی را وارد کنید");}}
                                onInput={(e) => e.target.setCustomValidity("")}
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="phoneNumber" className="text-sm text-gray-600 mb-1">:شماره تلفن</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                placeholder="شماره تلفن"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                onInvalid={(e) => {e.target.setCustomValidity("لطفاً شماره تلفن را وارد کنید");}}
                                onInput={(e) => e.target.setCustomValidity("")}
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="email" className="text-sm text-gray-600 mb-1">:ایمیل</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="ایمیل"
                            value={formData.email}
                            onInvalid={(e) => {e.target.setCustomValidity("لطفاً ایمیل را وارد کنید");}}
                            onInput={(e) => e.target.setCustomValidity("")}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام کاربری</label>
                        <input
                            type="text"
                            name="username"
                            placeholder="نام کاربری"
                            onInvalid={(e) => {e.target.setCustomValidity("لطفاً نام کاربری را وارد کنید");}}
                            onInput={(e) => e.target.setCustomValidity("")}
                            value={formData.username}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="kind" className="text-sm text-gray-600 mb-1">:نوع</label>
                        <Select
                            name="kind"
                            value={formData.kind}
                            onChange={handleKind}
                            className="w-full text-right font-custom"
                            placeholder="نوع کاربر"
                            options={[
                                { value: 0, label: "نامشخص", disabled: true },
                                { value: 1, label: "پزشکی" },
                                { value: 2, label: "دندانپزشکی" },
                                { value: 3, label: "آپارات" },
                                { value: 4, label: "ادمین کل", disabled: true },

                            ]}
                        />
                    </div>
                    <div className="flex gap-2">
                        
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="deviceType" className="text-sm text-gray-600 mb-1">:دستگاه</label>
                            <div className="relative">
                                <input
                                    type="text"
                                    name="deviceType"
                                    placeholder=""
                                    value={deviceType}
                                    className="w-full p-2 border text-right border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-8"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="role" className="text-sm text-gray-600 mb-1">:نقش</label>
                            <div className="relative">
                                <Select
                                    name="role"
                                    value={(formData.role)}
                                    onChange={e => handleRole(e)}
                                    className="w-full text-right font-custom"
                                    placeholder="انتخاب نقش"
                                    options={[
                                        { value: 0, className: "font-custom text-right", label: "ادمین" },
                                        { value: 1, className: "font-custom text-right", label: "دانشجو" },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>

                    
                    {showEtcField && (
                        <div className="flex gap-2">
                            <div className="flex flex-col w-1/2 text-right">
                                <label htmlFor="systemNumber" className="text-sm text-gray-600 mb-1">:شماره نظام</label>
                                <input
                                    type="text"
                                    name="systemNumber"
                                    value={formData.systemNumber}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-8"
                                    required
                                />
                            </div>
                            <div className="flex flex-col w-1/2 text-right">
                                <label htmlFor="signupDatetime" className="text-sm text-gray-600 mb-1">:تاریخ ثبت نام</label>
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={formData.signupDatetime}
                                    onChange={handleDateChange}
                                    calendarPosition="bottom-right"
                                    name="signupDatetime"
                                    className="h-8!important"
                                />
                            </div>
                        </div>
                    )}

                    {showEtcField && (
                        <div className="flex flex-col w-full text-right gap-2">
                            <label htmlFor="expirationDatetime" className="text-sm text-gray-600 mb-1">:تاریخ انقضا</label>
                            <div className="flex flex-wrap items-center gap-3 justify-end">
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={neverExpire ? null : formData.expirationDatetime}
                                    onChange={handleExpirationDateChange}
                                    calendarPosition="bottom-right"
                                    name="expirationDatetime"
                                    disabled={neverExpire}
                                />
                                <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={neverExpire}
                                        onChange={(e) => setNeverExpire(e.target.checked)}
                                    />
                                    بدون انقضا
                                </label>
                            </div>
                        </div>
                    )}
                    
                    {/* Reset Password Button */}
                    <button
                        type="button"
                        onClick={() => setResetModalVisible(true)}
                        className="w-full flex justify-center items-center gap-2 bg-red-500 hover:bg-yellow-600 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 mb-2"
                    >
                        تغییر رمز عبور
                    </button>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full flex justify-center items-center gap-2 bg-blue-500 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isLoading ? <FaSpinner className="animate-spin" /> : "به‌روزرسانی کاربر"}
                    </button>
                </form>
            </div>

            {/* Reset Password Modal */}
            <ResetPasswordModal
                visible={resetModalVisible}
                onClose={() => setResetModalVisible(false)}
                userId={formData.userID}
                isAdmin={formData.role === 0}
            />

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                className={"font-custom text-center rtl"}
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
        </div>
    );
};

export default UpdateUser;
